import workflowSelectStyles from "./workflowSelectStyles";

/** Render menus on <body> so they are not clipped by cards / overflow containers. */
export const selectMenuPortalProps = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "fixed",
};

/** React-select styles — follows `.donezo-workflow-page` CSS variables (light + dark). */
const DropDownStyles = {
  ...workflowSelectStyles,
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 10000,
  }),
};

export default DropDownStyles;
